import React from "react";
import { Route, Redirect } from "react-router-dom";
import GuestLayout from "../../layout/GuestLayout.jsx";
import PublicLayout from "../../layout/PublicLayout.jsx";
import ProtectedLayout from "../../layout/ProtectedLayout";
import ProtectedSupportLayout from "../../layout/ProtectedSupportLayout";
import ErrorPageLayout from "../../layout/ErrorPageLayout";
import EmptyLayout from "../../layout/EmptyLayout.jsx";

/**
 * Check if current path is a support path that bypasses auth
 */
const isSupportPath = () => {
  return (
    window.location.pathname === "/support/create" ||
    window.location.pathname.includes("/support/details")
  );
};

/**
 * Route for unauthenticated users only (login, register)
 * Redirects to home if logged in (except for support paths)
 */
export const GuestRoute = ({ component: Component, loggedIn, ...rest }) => {
  return (
    <GuestLayout>
      <Route
        {...rest}
        render={(props) =>
          loggedIn && !isSupportPath() ? (
            <Redirect to="/" />
          ) : (
            <Component {...props} />
          )
        }
      />
    </GuestLayout>
  );
};

/**
 * Route with PublicLayout - no auth required
 */
export const PublicRoute = ({ component: Component, ...rest }) => {
  return (
    <PublicLayout>
      <Route {...rest} render={(props) => <Component {...props} />} />
    </PublicLayout>
  );
};

/**
 * Route with EmptyLayout - no auth required, minimal UI
 */
export const EmptyRoute = ({ component: Component, ...rest }) => {
  return (
    <EmptyLayout>
      <Route {...rest} render={(props) => <Component {...props} />} />
    </EmptyLayout>
  );
};

/**
 * Route for authenticated users
 * @param {boolean} isForCreator - If true, only creators can access; if false, all authenticated users
 */
export const ProtectedRoute = ({
  component: Component,
  isForCreator,
  loggedIn,
  isCreator,
  ...rest
}) => {
  return (
    <ProtectedLayout>
      <Route
        {...rest}
        render={(props) =>
          (loggedIn && (isCreator === isForCreator || isForCreator === false)) ||
          isSupportPath() ? (
            <Component {...props} />
          ) : (
            <Redirect to="/" />
          )
        }
      />
    </ProtectedLayout>
  );
};

/**
 * Route for support pages with ProtectedSupportLayout
 */
export const ProtectedSupportRoute = ({
  component: Component,
  loggedIn,
  ...rest
}) => {
  return (
    <ProtectedSupportLayout>
      <Route
        {...rest}
        render={(props) =>
          loggedIn || isSupportPath() ? (
            <Component {...props} />
          ) : (
            <Redirect to="/" />
          )
        }
      />
    </ProtectedSupportLayout>
  );
};

/**
 * Route with ErrorPageLayout
 */
export const ErrorPageRoute = ({ component: Component, ...rest }) => {
  return (
    <ErrorPageLayout>
      <Route {...rest} render={(props) => <Component {...props} />} />
    </ErrorPageLayout>
  );
};
